import * as React from 'react';

function OpenBook(props) {
  return (
    <svg width={16} height={16} fill="none" {...props}>
      <path
        d="M8 4.028A5.978 5.978 0 004 2.5c-.701 0-1.375.12-2 .341v9.5A5.994 5.994 0 014 12c1.537 0 2.939.578 4 1.528m0-9.5A5.977 5.977 0 0112 2.5c.701 0 1.375.12 2 .341v9.5A5.994 5.994 0 0012 12a5.978 5.978 0 00-4 1.528m0-9.5v9.5"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

const OpenBookIcon = React.memo(OpenBook);
export default OpenBookIcon;
